import { ProfileSection } from './ProfileSection';
import { RESTRICTION_KEYS, type MarketingDraft, type RestrictionKey } from './marketingDraft';

const RESTRICTION_OPTIONS: Record<RestrictionKey, { label: string; testId: string }> = {
  seniorHousing: { label: 'Senior Housing (55+ community)', testId: 'restriction-senior-housing' },
  studentHousing: { label: 'Student Housing', testId: 'restriction-student-housing' },
  militaryHousing: { label: 'Military Housing', testId: 'restriction-military-housing' },
  disabledHousing: { label: 'Disabled / Accessible Housing', testId: 'restriction-disabled-housing' },
  incomeRestricted: { label: 'Income Restricted', testId: 'restriction-income-restricted' },
};

interface Props {
  draft: MarketingDraft;
  onChange: (patch: Partial<MarketingDraft>) => void;
}

export function ProfileSectionRestrictions({ draft, onChange }: Props) {
  return (
    <ProfileSection title="Housing restrictions" testId="marketing-details-restrictions">
      <p className="mb-2 text-xs text-muted-foreground">
        Indicate if this unit qualifies for any special housing programs or communities. These flags are saved with the
        unit's marketing details.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2">
        {RESTRICTION_KEYS.map((key) => (
          <label
            key={key}
            className="flex min-h-[44px] cursor-pointer items-center gap-2 rounded-md px-2 transition-colors hover:bg-muted/50"
          >
            <input
              type="checkbox"
              checked={draft.restrictions[key]}
              onChange={() => onChange({ restrictions: { ...draft.restrictions, [key]: !draft.restrictions[key] } })}
              className="h-4 w-4 shrink-0 rounded border-input text-primary"
              data-testid={RESTRICTION_OPTIONS[key].testId}
            />
            <span className="text-sm text-foreground">{RESTRICTION_OPTIONS[key].label}</span>
          </label>
        ))}
      </div>
    </ProfileSection>
  );
}
